// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__4AINy","item":"styles_item__MR13g","card-img-content":"styles_card-img-content__F451G"};